import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://teacher-material-backend-production.up.railway.app/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth endpoints
export const authAPI = {
  signup: (data) => api.post('/auth/signup', data),
  login: (data) => api.post('/auth/login', data),
  getCurrentUser: () => api.get('/auth/me'),
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
};

// Subscription endpoints
export const subscriptionAPI = {
  getPlans: () => api.get('/subscriptions/plans'),
  getCurrentSubscription: () => api.get('/subscriptions/current'),
  getUsage: () => api.get('/subscriptions/usage'),
  createCheckout: (planType) => api.post('/subscriptions/checkout', { planType }),
};

// Material generation endpoint (we'll implement this in backend later)
export const materialsAPI = {
  generate: (data) => api.post('/materials/generate', data),
  getHistory: () => api.get('/materials/history'),
toggleFavorite: (id) => api.patch(`/materials/${id}/favorite`),
deleteMaterial: (id) => api.delete(`/materials/${id}`),          
};

export default api;